import { render, staticRenderFns } from "./RowMailTemplates.vue?vue&type=template&id=6d2e237d"
import script from "./RowMailTemplates.vue?vue&type=script&lang=js"
export * from "./RowMailTemplates.vue?vue&type=script&lang=js"
import style0 from "./RowMailTemplates.vue?vue&type=style&index=0&id=6d2e237d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports